import { PageTitle } from 'src/ui/shared/components/page-components/PageTitle';

export const OrganisationSettingsPageNav = (): React.ReactElement => {
    return <PageTitle>Organisation communication settings</PageTitle>;
};
